import { useEffect, useRef } from 'react';

import { useI18n } from '#/i18n/hooks/useI18n';
import { dismissToast, showToast } from '#/zustand-stores/toastsStore';

export function UnpublishedJobToast() {
  const { i18n } = useI18n();
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (!isFirstRender.current) return;

    const toastId = showToast({
      id: 'unpublished-job-toast',
      headline: i18n('This listing has been unpublished'),
      body: i18n(
        'This listing has been unpublished and is no longer accepting applications.',
      ),
      dismissible: true,
      variant: 'warning',
    });

    isFirstRender.current = false;

    return () => {
      dismissToast(toastId);
    };
  }, [i18n]);

  return null;
}
